const PERF_FLAG_KEY = 'enablePerfLogs';

const now = () => {
  if (typeof performance !== 'undefined' && performance.now) {
    return performance.now();
  }
  return Date.now();
};

export const isPerfLoggingEnabled = () => {
  if (typeof window === 'undefined') return false;
  return (
    window.localStorage.getItem(PERF_FLAG_KEY) === '1'
    || process.env.NODE_ENV !== 'production'
  );
};

export const logPerf = (label, durationMs, metadata = {}) => {
  if (!isPerfLoggingEnabled()) return;
  const rounded = Number(durationMs).toFixed(2);
  // eslint-disable-next-line no-console
  console.info(`[perf] ${label} took ${rounded}ms`, metadata);
};

export const measureAsync = async (label, fn, metadata = {}) => {
  const startedAt = now();
  try {
    return await fn();
  } finally {
    logPerf(label, now() - startedAt, metadata);
  }
};

export const setPerfLoggingEnabled = (enabled) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(PERF_FLAG_KEY, enabled ? '1' : '0');
};
